export const shouldDisplayVisuallySimilar = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.visualNavigation;
};

export const shouldDisplayIrgaccessories = (data = {}) => {
  return (data?.product?.info?.recommendationFlags?.ACC);
};

export const shouldDisplayIrgcollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.collections;
};
